<ng-template
  #notificationItemTpl
  let-notificationItem="notificationItem"
  let-notificationType="notificationType"
>
  <ng-container *ngIf="getTypedNotificationItem(notificationItem) as n">
    <ng-container *ngIf="getTypedNotificationItemType(notificationType) as type">
      <div data-test="qFC2HZO9" class="message-alert" [ngClass]="alertClasses[type]">
        <div data-test="V8F6oP4k" class="message-alert__header">
          <p
            data-test="vRSC2b4A"
            class="text-sm text-center"
            [style.text-align]="!n.items?.length ? 'center' : ''"
            [innerHTML]="n.title"
          ></p>
        </div>
        <div data-test="54Wl58_2" class="message-alert__text" *ngIf="!!n.items?.length">
          <ul data-test="NeHvVp90">
            <li
              data-test="O28dn_f7"
              *ngFor="let message of n.items"
              [innerHTML]="message"
            ></li>
          </ul>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<md-modal
  data-test="LJyRgO92"
  *ngIf="hasNotifications()"
  #notificationsModal
  [openOnInit]="true"
  (afterClose)="close()"
>
  <md-modal-title data-test="_O8oQDih" *ngIf="notification?.title">
    <div data-test="QKxLaL7w" class="modal__title">
      <h2 data-test="PMeSP5Xs">
        {{ notification?.title }}
      </h2>
    </div>
  </md-modal-title>
  <md-modal-content data-test="JSYPGWcm">
    <ng-container *ngFor="let notificationType of notificationTypes">
      <ng-container
        *ngTemplateOutlet="
          notificationItemTpl;
          context: {
            notificationItem: notification && notification[notificationType],
            notificationType: notificationType
          }
        "
      ></ng-container>
    </ng-container>
  </md-modal-content>
  <md-modal-actions data-test="6lZAIkng">
    <div data-test="5h1GqCcs" class="col-auto m-auto text-center">
      <button
        data-test="B9HCDGxe"
        class="button button_primary button_large button_uppercase"
        (click)="close()"
      >
        ok
      </button>
    </div>
  </md-modal-actions>
</md-modal>
